import React, { useEffect, useState } from "react";
import { ILayoutTemplate } from "../../../Context/PDFEditorContext";
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useUserContext } from "../../../Context/UserContext";
import { UploadTinyMce } from "../../../Services/UploadFileService";

type Props = {
  template: ILayoutTemplate;
  h: number;
  w: number;
  onUploadComplete: (url: string) => void;
};

const StaticImage = ({ template, h, w, onUploadComplete }: Props) => {
  const [loading, setLoading] = useState(false);
  var _userData = JSON.parse(window.localStorage.getItem("userData") || "");
  const [userData, setUserData] = useUserContext();
  const _sharepointSiteURL = _userData.SharepointSiteURL;
  const [imageUrl, setImageUrl] = useState<string>("");
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const fetchData = () => {
      try {
        const link = getLink(template.value);
        setImageUrl(link);
      } catch (error) {
        // Handle error
        console.error("Error fetching image link:", error);
      }
    };

    fetchData();
  }, [template.value]);
  console.log(template);
  const imgSize = {
    contain:
      h > w
        ? {
            width: "100%",
          }
        : { height: "100%", width: "auto" },
    cover: {},
    fill: { width: "100%", height: "100%" },
  };
  const getLink = (val: string) => {
    if (template.value === "") {
      return "";
    }
    let imgUrl = "";
    const protocol = window.location.protocol;

    if (_sharepointSiteURL) {
      imgUrl = _sharepointSiteURL + "/" + val;
    } else {
      const _port = window.location.port;
      let _tinyURL = _userData.TinyURL;
      if (_port) {
        _tinyURL = _userData.TinyURL;
      }
      imgUrl = `${protocol}//` + _tinyURL + val;
    }

    return imgUrl !== ""
      ? imgUrl
      : "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png";
  };

  const handlePreviewClick = () => {
    setVisible(true);
  };

  const handleModalClose = () => {
    setVisible(false);
  };
  const checkFile = (file: File) => {
    setLoading(true);
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
    }
    return isImage;
  };

  const uploadButton = (
    <div>
      {loading ? (
        <LoadingOutlined rev={undefined} />
      ) : (
        <PlusOutlined rev={undefined} />
      )}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <>
      {imageUrl !== "" ? (
        <>
          {template.attribute?.backgroundSize !== "cover" ? (
            <img
              className="content"
              src={imageUrl}
              alt={template.label}
              style={imgSize[template.attribute?.backgroundSize]}
            />
          ) : (
            <div
              style={{
                overflow: "hidden",
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            >
              <img
                className="content"
                src={imageUrl}
                alt={template.label}
                style={imgSize[template.attribute?.backgroundSize]}
              />
            </div>
          )}
        </>
      ) : (
        <Upload
          className="static-img"
          listType="picture-card"
          beforeUpload={checkFile}
          showUploadList={false}
          onChange={async (e) => {
            if (e.file.originFileObj) {
              const uploadedFile = e.file.originFileObj;
              if (uploadedFile) {
                const file = new File([uploadedFile], uploadedFile.name, {
                  lastModified: Date.now(),
                });
                const formData = new FormData();
                formData.append("file", file);
                formData.append("Doclib", "TempAttachment");
                formData.append("docSet", "TinyImages");
                formData.append("fileDesc", "");
                formData.append("actorID", userData.EmployeeId.toString());

                var response: any = await UploadTinyMce(formData);
                console.log(response);
                if (response?.data?.result) {
                  getLink(response.data.pathUrl);
                  onUploadComplete(response.data.pathUrl);
                }
              }
            }

            setLoading(false);
          }}
          // fileList={fileList}
          style={{ height: "100%" }}
        >
          {uploadButton}
        </Upload>
      )}
    </>
  );
};

export default StaticImage;
